import { render, staticRenderFns } from "./CoffInputSelect.vue?vue&type=template&id=da3affe6&scoped=true"
import script from "./CoffInputSelect.vue?vue&type=script&lang=js"
export * from "./CoffInputSelect.vue?vue&type=script&lang=js"
import style0 from "./CoffInputSelect.vue?vue&type=style&index=0&id=da3affe6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da3affe6",
  null
  
)

export default component.exports